export const RESET = 'EXCMCAR_LIST_RESET'
export const SET_ITEMS = 'EXCMCAR_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCAR_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCAR_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCAR_LIST_TOGGLE_LOADING'
